module.exports = __webpack_public_path__ + "static/media/ODD.459b3f58.png";